export const Experiments = {
	projectTheming: 'projectTheming',
	isSampleProject: 'isSampleProject',
	isNotSampleProject: 'isNotSampleProject',
	trelloCrossflow: 'trelloCrossflow',
} as const;
